import { useState } from "react";
import { Link } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import Breadcrumb from "@/components/base/Breadcrumb";

const faqs = [
  {
    q: "91看片提供真实的在线播放吗？",
    a: "本站为演示项目，播放入口仅为界面展示，不接入真实视频源，无法实际播放。请通过正规授权平台观看正版内容。",
  },
  {
    q: "如何快速找到想看的影片？",
    a: "你可以使用顶部搜索框输入片名关键词，或在「电影」「电视剧」分类页通过地区、年份、类型多维筛选，并结合热门度、新上架、评分排序快速定位。",
  },
  {
    q: "站内影视和资讯数据是真实的吗？",
    a: "所有影视作品与资讯内容均为演示示例数据，用于展示功能与设计，不代表真实的上映或发行信息。",
  },
  {
    q: "内容多久更新一次？",
    a: "演示站点的数据为静态示例。在正式运营中，影视资源与资讯将按日更新，热门榜单也会实时刷新。",
  },
];

const values = [
  {
    icon: "ri-search-eye-line",
    title: "高效查找",
    desc: "多维筛选与排序组合，帮助你在海量作品中快速定位想看的内容。",
  },
  {
    icon: "ri-hd-line",
    title: "高清内容",
    desc: "聚焦高清影视资源，画质与信息展示清晰，浏览体验舒适不疲劳。",
  },
  {
    icon: "ri-newspaper-line",
    title: "资讯同步",
    desc: "影视新闻、深度评论与专题观察同步更新，掌握行业一手动态。",
  },
];

export default function AboutPage() {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <title>关于我们 - 91看片高清影视平台介绍</title>
      <meta
        name="description"
        content="了解91看片：一个聚焦高清电影、电视剧在线观看与影视资讯的门户平台，为影视爱好者提供便捷、清晰的查找与浏览体验。"
      />
      <SiteHeader />

      <main className="flex-1">
        <section className="border-b border-background-200 bg-background-100">
          <div className="mx-auto max-w-site px-4 py-6 md:px-6 md:py-8">
            <Breadcrumb items={[{ label: "关于我们" }]} />
            <h1 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              关于 91看片
            </h1>
            <p className="mt-2 max-w-3xl text-sm leading-6 text-foreground-600">
              一个为影视爱好者打造的高清影视与资讯门户，专注内容展示与查找体验。
            </p>
          </div>
        </section>

        <div className="mx-auto max-w-site px-4 py-10 md:px-6">
          {/* 定位介绍 */}
          <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-2">
            <div>
              <span className="inline-block rounded bg-secondary-100 px-2 py-0.5 text-xs font-medium text-secondary-900">
                站点定位
              </span>
              <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950">
                让找片变得简单而愉快
              </h2>
              <p className="mt-4 text-sm leading-7 text-foreground-600">
                91看片是一个以高清电影、电视剧在线观看及影视资讯为主题的门户平台。我们面向喜欢通过网络观看电影电视剧的中青年影视爱好者，覆盖预算有限、追求高清内容和多样选择的观众群体。
              </p>
              <p className="mt-3 text-sm leading-7 text-foreground-600">
                通过清晰的分类结构、多维度的筛选条件与实时的热门榜单，我们希望帮助每一位观众用最短的时间找到最想看的那一部，同时用及时、专业的资讯内容陪伴你的观影生活。
              </p>
            </div>
            <div className="h-[260px] w-full overflow-hidden rounded-lg md:h-[340px]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimal%20creative%20studio%20workspace%20with%20a%20large%20monitor%20showing%20a%20film%20catalog%20grid%2C%20notebooks%20and%20a%20cup%20of%20coffee%2C%20soft%20daylight%20through%20wide%20windows%2C%20warm%20teal%20and%20cream%20tones%2C%20calm%20productive%20atmosphere%2C%20editorial%20photography%2C%20high%20detail&width=1000&height=720&seq=about-01&orientation=landscape"
                alt="91看片 内容团队工作场景"
                title="91看片 - 高清影视与资讯门户"
                className="h-full w-full object-cover object-top"
              />
            </div>
          </div>

          {/* 价值观 */}
          <div className="mt-14 grid grid-cols-1 gap-5 sm:grid-cols-3">
            {values.map((item) => (
              <div
                key={item.title}
                className="rounded-lg border border-background-200 bg-background-50 p-6"
              >
                <span className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary-600 text-background-50">
                  <i className={`${item.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">
                  {item.title}
                </h3>
                <p className="mt-2 text-sm leading-6 text-foreground-500">{item.desc}</p>
              </div>
            ))}
          </div>

          {/* 联系方式 */}
          <div className="mt-14 rounded-lg border border-background-200 bg-background-100 p-6 md:p-8">
            <h2 className="font-heading text-xl font-bold text-foreground-950">
              联系我们
            </h2>
            <p className="mt-2 text-sm text-foreground-600">
              如对本站有建议或合作意向，欢迎通过以下方式联系我们（以下信息为演示用途）。
            </p>
            <div className="mt-5 grid grid-cols-1 gap-4 sm:grid-cols-3">
              {[
                { icon: "ri-mail-line", label: "反馈邮箱", value: "support@91kanpian.demo" },
                { icon: "ri-customer-service-2-line", label: "在线支持", value: "工作日 9:00 - 18:00" },
                { icon: "ri-map-pin-line", label: "办公地点", value: "线上演示平台" },
              ].map((item) => (
                <div
                  key={item.label}
                  className="flex items-start gap-3 rounded-lg border border-background-200 bg-background-50 p-4"
                >
                  <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={`${item.icon} text-xl`}></i>
                  </span>
                  <div>
                    <p className="text-xs text-foreground-400">{item.label}</p>
                    <p className="mt-0.5 text-sm font-medium text-foreground-900">
                      {item.value}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 常见问题 */}
          <div className="mt-14">
            <h2 className="font-heading text-xl font-bold text-foreground-950">
              常见问题与使用说明
            </h2>
            <div className="mt-5 overflow-hidden rounded-lg border border-background-200">
              {faqs.map((faq, index) => {
                const open = openIndex === index;
                return (
                  <div key={faq.q} className="border-b border-background-200 last:border-b-0">
                    <button
                      type="button"
                      onClick={() => setOpenIndex(open ? -1 : index)}
                      className="flex w-full items-center justify-between gap-4 bg-background-50 p-4 text-left transition-colors hover:bg-background-100 md:p-5"
                    >
                      <span className="text-sm font-medium text-foreground-900 md:text-base">
                        {faq.q}
                      </span>
                      <i
                        className={`shrink-0 text-xl text-primary-700 transition-transform ${
                          open ? "ri-subtract-line" : "ri-add-line"
                        }`}
                      ></i>
                    </button>
                    {open && (
                      <p className="bg-background-50 px-4 pb-5 text-sm leading-7 text-foreground-600 md:px-5">
                        {faq.a}
                      </p>
                    )}
                  </div>
                );
              })}
            </div>
          </div>

          <div className="mt-12 flex flex-col items-center justify-center gap-3 rounded-lg bg-primary-900 px-6 py-10 text-center">
            <h2 className="font-heading text-xl font-bold text-background-50 md:text-2xl">
              开始探索你的下一部好片
            </h2>
            <p className="text-sm text-background-300">
              海量高清影视与新鲜资讯，等你来发现
            </p>
            <div className="mt-2 flex flex-wrap justify-center gap-3">
              <Link
                to="/category/movie"
                className="flex items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
              >
                <i className="ri-film-line"></i>
                浏览电影
              </Link>
              <Link
                to="/category/tv"
                className="flex items-center gap-1 whitespace-nowrap rounded-md border border-background-50/30 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
              >
                <i className="ri-tv-2-line"></i>
                浏览电视剧
              </Link>
            </div>
          </div>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}